import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex h-100 bg-white',
    wrap: 'relative container flex flex-col justify-end pb-6 md:justify-center',
    brandLogo: 'mb-6 h-auto max-w-48 md:mb-11 md:w-auto md:max-w-max',
    body: 'mb:pb-5 pr-3 pl-3 md:pr-10 md:pl-10',
    video: 'absolute top-0 left-0 h-full w-full object-cover',
    link: 'link ml-1.5 inline-flex items-center text-base font-semibold uppercase md:ml-0 xl:mb-0',
    linkArrow: 'flex-center h-10 w-10'
  }
});
